// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TOY3V","fullWidth":"styles_fullWidth__213lI","title":"styles_title__L015H"};